var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgCheck = function SvgCheck(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 61 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#check_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.457 1.045.29 24.729a2.037 2.037 0 0 0 0 2.091l14.167 23.685c.19.317.464.581.793.765.329.183.702.28 1.082.28h28.34c.38 0 .754-.097 1.083-.28a2.13 2.13 0 0 0 .792-.765L60.715 26.82a2.036 2.036 0 0 0 0-2.09L46.547 1.044a2.128 2.128 0 0 0-.79-.768 2.225 2.225 0 0 0-1.084-.283h-28.34c-.381 0-.755.098-1.084.283-.33.184-.603.449-.792.768Z",
    fill: "#005537"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.196 20.5 29.121 32.96c-.31.329-.732.495-1.143.495-.412 0-.825-.165-1.143-.495l-6.033-6.23a1.695 1.695 0 0 1 0-2.36 1.57 1.57 0 0 1 2.286 0l4.89 5.05 10.925-11.28a1.581 1.581 0 0 1 2.295 0 1.717 1.717 0 0 1 0 2.36h-.002Z",
    fill: "#F2F1EC"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "check_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "matrix(0 -1 1 0 0 51.55)",
    d: "M0 0h51.549v61H0z"
  })))));
};
export default SvgCheck;